import { render, staticRenderFns } from "./faqSection.vue?vue&type=template&id=ac72226a&scoped=true&"
import script from "./faqSection.vue?vue&type=script&lang=js&"
export * from "./faqSection.vue?vue&type=script&lang=js&"
import style0 from "./faqSection.vue?vue&type=style&index=0&id=ac72226a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac72226a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac72226a')) {
      api.createRecord('ac72226a', component.options)
    } else {
      api.reload('ac72226a', component.options)
    }
    module.hot.accept("./faqSection.vue?vue&type=template&id=ac72226a&scoped=true&", function () {
      api.rerender('ac72226a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/onboarding/client/teamEvaluation/faqSection.vue"
export default component.exports